var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#00B2FD",
    stroke: "#00B2FD"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.217 30.243c-1.219.801-4.253 2.392-5.095 2.672-.135.045-.161.195-.062.354.435.7 3.497-.262 6.186-1.947 4.83-3.022 10.52-8.7 13.634-13.601 1.38-2.174 3.81-7.052 4.713-9.464l.609-1.628.213 2.982c.171 2.4.283 3.028.568 3.205.259.161.45.143.707-.069.315-.26.345-.871.284-5.705-.055-4.338-.13-5.508-.383-5.887-.671-1.007-1.308-.868-2.393.523-5.664 7.273-5.783 7.443-5.576 7.98.268.693 1.05.338 2.528-1.143.81-.811 1.503-1.446 1.54-1.408.098.097-1.222 3.3-2.34 5.676-3.358 7.148-8.533 13.116-15.133 17.46",
    transform: "translate(-217 -336) matrix(1 0 0 -1 218 370)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.879a24f0cee754ccfe1fdf51faac6338.svg";
export { ForwardRef as ReactComponent };